import styled from 'styled-components';
import { Loader as SemanticLoader } from 'semantic-ui-react';

export const Container = styled.div`
  display: flex;
  margin-top: 55px;
  flex-direction: column;
  height: 80%;
`;

export const ContainerPlayer = styled.div`
  width: 100%;
  height: 100%;

  .video-js {
    width: 100%;
    height: 100%;
  }
`;

export const Loader = styled(SemanticLoader).attrs(() => ({
  active: true,
}))``;
